module.exports = __webpack_public_path__ + "static/media/aa-homepage.6fc53e2d.png";